import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 10 10\" id=\"cross\"><path d=\"M9.642 1.961 6.614 4.994l3.028 3.034c.45.451.45 1.182 0 1.634a1.15 1.15 0 0 1-1.63 0L4.984 6.628 1.956 9.662a1.149 1.149 0 0 1-1.629 0 1.156 1.156 0 0 1 0-1.634l3.027-3.034L.326 1.961a1.158 1.158 0 0 1 0-1.634 1.151 1.151 0 0 1 1.63 0l3.028 3.034L8.011.327a1.151 1.151 0 0 1 1.63 0c.451.451.451 1.182.001 1.634Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol